import { apiSlice } from '../../api/apiSlice';

export const questionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    setQuestionPoint: builder.mutation({
      query: (options) => ({
        url: `Question/${options.questionId}/assignment/${options.assignmentId}/questionPoint?maxPoint=${options.maxPoint}`,
        method: 'POST',
        credentials: 'include'
      })
    })
  })
});

export const {
  useSetQuestionPointMutation
} = questionApi;